<script setup>
  import { computed } from 'vue';
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    type: {
      type: String,
      default: 'button'
    },
    pinned: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    accessibleLabel: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    warningIcon: {
      type: String,
      required: false
    }
  });

  const classObject = computed(() => ({
    'jwx-button-control--pinned': props.pinned,
    'jwx-button-control': true
  }));

</script>

<template>
  <button 
    :type="props.type"
    :class="classObject"
    :disabled="props.disabled"
  >
    <slot></slot>
    <Icon name="pin-solid" v-if="props.pinned" class="jwx-button-control__pin" />
    <Icon name="lock-solid" v-if="props.locked" class="jwx-button-control__locked" />
    <span v-if="props.accessibleLabel" class="jwx-button-control__accessible-label">{{ accessibleLabel }}</span>
  </button>
</template>